import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { UnauthenticatedNotFound } from '@/components/not-found';
import { registerRouter } from '@/lib/router-registry';
import { RoutePendingLoader } from '@/layout/RoutePendingLoader';

export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: UnauthenticatedNotFound,
  defaultPendingComponent: RoutePendingLoader,
  defaultPendingMs: 250,
  defaultPendingMinMs: 400,
  context: {
    auth: undefined!,
    queryClient: undefined!
  }
});

registerRouter(router);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
